import React, {useEffect, useState} from 'react';
import moment from 'moment';
import FeedPreviewModal from './modals/FeedPreviewModal';
import FeedDeleteModal from './modals/FeedDeleteModal';
import {assignAlertToUsers, getRssLink} from 'utils/api';
import './style.scss';
import {CustomInput, FormGroup, Input, Label} from 'reactstrap';
import Loader from 'components/Loader';
import Tooltip from 'components/Tooltip';

const FeedsListItem = ({item, refreshList, auth, profile}) => {
    let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    let [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    let [rssUrl, setRssUrl] = useState(null);
    let [rssUrlLoading, setRssUrlLoading] = useState(false);
    let [hasDailyAlerts, setHasDailyAlerts] = useState(false);
    let [saving, setSaving] = useState(false);

    useEffect(() => {
        item.userAlerts && item.userAlerts.length > 0 && setHasDailyAlerts(true);
    }, [item]);

    const convertDateString = (date) => moment(date).local().format('MM/DD/YYYY');

    const getSourceIcon = (type) => {
        switch(type) {
            case 'facebook':
                return <i style={{color: '#3b5998', fontSize: '20px', marginRight: '0.5rem'}}
                          className="fab fa-facebook-square"/>;
            case 'twitter':
                return <i style={{color: '#1da1f2', fontSize: '20px', marginRight: '0.5rem'}}
                          className="fab fa-twitter-square"/>;
            case 'rss':
                return <i style={{color: '#ee802f', fontSize: '20px', marginRight: '0.5rem'}} className="fas fa-rss"/>;
            case 'google_ozmosys':
                return <i style={{color: '#314784', fontSize: '20px', marginRight: '0.5rem'}}
                          className="fas fa-globe"/>;
                ;
            case 'youtube':
                return <i style={{color: '#FF0000', fontSize: '20px', marginRight: '0.5rem'}}
                          className="fab fa-youtube"/>;
            case 'instagram':
                return <i style={{fontSize: '20px', marginRight: '0.5rem'}}
                          className="fab fa-instagram instagram-feed-icon"/>;
            default:
                return <i style={{color: '#6E7179', fontSize: '20px', marginRight: '0.5rem'}} className="fas fa-cog"/>;
        }
    };

    const assignAlertToSingerUser = async() => {
        try {
            setSaving(true);
            if(!hasDailyAlerts) {
                await assignAlertToUsers(item.id, [profile.id], 'daily');
                setHasDailyAlerts(true);
            } else {
                await assignAlertToUsers(item.id, [], 'daily');
                setHasDailyAlerts(false);
            }
            setSaving(false);
        } catch(err) {
            setSaving(false);
            console.log(err);
        }
    };

    const toggleDailyAlert = () => {
        assignAlertToSingerUser();
    };

    const copyLink = async() => {
        try {
            let url;
            if(rssUrl) {
                url = rssUrl;
            } else {
                //let globalDomain = new URL(window.location.href).origin;
                setRssUrlLoading(true);
                let data = await getRssLink(item.id);
                url = data.content.url;
                setRssUrl(url);
                setRssUrlLoading(false);
            }
            let textField = document.createElement('textarea');
            textField.innerText = url;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();
        } catch(err) {
            console.log(err);
        }
    };

    return (
        <tr className="table_row">
            {isPreviewModalOpen &&
            <FeedPreviewModal
                isOpen={isPreviewModalOpen}
                toggle={() => setIsPreviewModalOpen(prevState => !prevState)}
                source={item}
            />
            }
            {isDeleteModalOpen &&
            <FeedDeleteModal
                isOpen={isDeleteModalOpen}
                toggle={() => setIsDeleteModalOpen(prevState => !prevState)}
                source={item}
                refreshList={refreshList}
            />
            }
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Name</strong>
                {item.discriminator === 'web_resource_item' ?
                    <>
                        <div className="table-title_container">
                            <i style={{color: '#314784', fontSize: '20px'}} className="mr-2 fas fa-globe"/>
                            <a href={item.url}
                               target="noopener noreferrer_blank"
                               style={{textDecoration: 'underline'}}
                               data-tip="Open Fetch source"
                            >
                                {item.attachedName}
                            </a>
                        </div>
                    </>
                    :
                    <>
                        <Tooltip placement="bottom" tooltip="Open Fetch source">
                            <div className="table-title_container">
                                <div style={{width: '30px'}}>{getSourceIcon(item.type)}</div>
                                <span>
                                <a href={item.url}
                                   target="noopener noreferrer_blank"
                                   className="link-style"
                                   data-tip="Open Fetch source"
                                >
                                {item.attachedName}
                                </a>
                            </span>
                            </div>
                        </Tooltip>
                    </>
                }
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">RSS Feed</strong>
                {rssUrlLoading ?
                    // <i className="fa fa-spinner fa-spin"/>
                    <Loader small/>
                    :
                    <>
                        <Tooltip placement="bottom" tooltip="Copy to Clipboard">
                            <i
                                className="rssIcon mr-2 fas fa-rss-square"
                                id={`rss-${item.id}`}
                                onClick={() => {
                                    copyLink(item.url);
                                }}
                            />
                        </Tooltip>
                    </>
                }
            </td>
            {auth.isSingleUser &&
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Daily Alerts</strong>
                <FormGroup className="custom-form-checkbox d-flex" check>
                    <CustomInput
                        inline
                        type="checkbox"
                        name="sendDailyAlerts"
                        id={`admin-checkbox-${item.id}`}
                        onChange={toggleDailyAlert}
                        checked={hasDailyAlerts}
                        style={{paddingLeft: 0}}
                    />
                </FormGroup>
                {/*<FormGroup check>*/}
                {/*    <Label check>*/}
                {/*        <Input*/}
                {/*            type="checkbox"*/}
                {/*            checked={hasDailyAlerts}*/}
                {/*            onClick={() => toggleDailyAlert()}*/}
                {/*        />{' '}*/}
                {/*        &nbsp;*/}
                {/*    </Label>*/}
                {/*    {saving && window.innerWidth > 1250 && <i className="fas fa-spinner fa-spin"/>}*/}
                {/*</FormGroup>*/}
            </td>
            }
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Created At</strong>
                {convertDateString(item.createdAt)}
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Parsed At</strong>
                {item.lastParseTime === null ? 'Pending updates' : convertDateString(item.lastParseTime)}
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Updated At</strong>
                {item.contentUpdatedAt === null ? 'Pending updates' : convertDateString(item.contentUpdatedAt)}
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Status</strong>
                <span
                    id={'feed_status' + item.id}
                    style={item.status === 1 ? {} : {/* color: 'red', fontWeight: '700' */}}
                >
                    {item.status === 1 ? 'Active' : 'Inactive'}
                </span>
            </td>
            <td className="table_column column_action" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Actions</strong>
                <div style={{width: '60px', display: 'flex'}}>
                    <Tooltip placement="bottom" tooltip="Preview">
                        <i
                            onClick={() => setIsPreviewModalOpen(true)}
                            className="feedsActions far fa-eye"
                            style={{marginRight: '5px'}}
                        />
                    </Tooltip>
                    <Tooltip placement="bottom" tooltip="Delete">
                        <i
                            onClick={() => setIsDeleteModalOpen(true)}
                            className="feedsActions fas fa-trash-alt"
                            id={'keks' + item.id}
                            data-tip="Delete"
                        />
                    </Tooltip>
                </div>
            </td>
        </tr>
    );
};

export default FeedsListItem;